// extracted by mini-css-extract-plugin
export default {"ordinalInput":"_1LszUEJiCkPddNUJzhZaj9"};